import {Box, Button, Modal} from "@mui/material";
import CategoryList, {CategoryListProps} from "pages/Material/components/CategoryList/index";
import {useState} from "react";
import ChevronRight from "assets/icons/ChevronRight";

interface CategoryListModalProps extends CategoryListProps {
}

const CategoryListModal = ({

                             setSelectedCategory,
                             selectedSubcategory,
                             setSelectedSubcategory,
                             selectedCategory
                           }: CategoryListModalProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const onClose = () => setIsOpen(false);
  return (
    <>
      <Button
        onClick={() => setIsOpen(true)}
        endIcon={<ChevronRight sx={{width: 20, height: 20}}/>}
        sx={{
          px: 2,
          py: 1,
          backgroundColor: 'primary.main',
          color: '#fff',
          mb: 2.5,
          fontFamily: '"Pragmatica Extended", Arial, sans-serif',
          fontSize: 12,
          fontWeight: 500,
          lineHeight: '110%'
        }}>
        Категории
      </Button>
      {isOpen && (
        <Modal open={isOpen} onClose={onClose}>
          <Box sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'white',
            width: '80%',
            px: 3.5,
            py: 4
          }}>
            <CategoryList selectedCategory={selectedCategory}
                          setSelectedCategory={setSelectedCategory}
                          selectedSubcategory={selectedSubcategory}
                          setSelectedSubcategory={setSelectedSubcategory}
                          onClose={onClose}
            />
          </Box>
        </Modal>
      )}
    </>
  )
}
export default CategoryListModal
